import React, { useEffect } from 'react';

import {
  FormControlLabel, FormLabel, Radio, RadioGroup, useTheme,
} from '@mui/material';

import {
  ErrorSelect, Mark, MarksContainer,
} from './index.styles';

interface MarksSelectProps {
  maxMark: number;
  onChange?: (mark: number, errorType?: string) => void;
  selectError?: (errorType: string) => void;
  selectedError?: string;
  selectedMark?: number;
  disabled?: boolean;
}

const ERROR_TYPES = [
  {
    key: 'missed',
    value: 'MISSED',
    label: 'Missed Marks',
  },
  {
    key: 'silly',
    value: 'SILLY',
    label: 'Silly Mistake',
  },
  {
    key: 'inaccuracy',
    value: 'INACCURACY',
    label: 'Inaccuracy',
  },
];

const MarksSelect = ({ maxMark,
  onChange = () => {},
  selectError,
  selectedError,
  selectedMark,
  disabled = false }: MarksSelectProps) => {
  const theme = useTheme();

  const handleMarkClick = (mark: number) => {
    if (!disabled) onChange(mark, selectedError);
  };

  const handleErrorSelect = (errorType: string) => {
    if (selectError) selectError(errorType);
  };

  useEffect(() => {
    if (selectedMark === maxMark) {
      handleErrorSelect('');
    }
  }, [selectedMark]);

  return (
    <>
      {!disabled && <FormLabel>Select mark</FormLabel>}
      <MarksContainer>
        {[...Array(maxMark + 1)].map((_, index) => (
          <Mark
            isActive={((selectedMark !== undefined) && (index <= selectedMark))}
            isSelected={((selectedMark !== undefined) && (index === selectedMark))}
            onClick={() => handleMarkClick(index)}
            key={Math.random() + index.toString()}
            disabled={disabled}
          >
            {index}
          </Mark>
        ))}
      </MarksContainer>
      {
        selectError && (
          <ErrorSelect>
            {!disabled && <FormLabel>Select primary error</FormLabel>}
            <RadioGroup
              value={selectedError}
              onChange={(event) => handleErrorSelect(event.target.value)}
            >
              {ERROR_TYPES.map((errorType) => (
                <FormControlLabel
                  key={errorType.key}
                  value={errorType.value}
                  control={(
                    <Radio
                      sx={{
                        '&.Mui-checked': {
                          color: theme.palette.primary.dark,
                        },
                      }}
                    />
                  )}
                  label={errorType.label}
                  disabled={disabled || selectedMark === maxMark}
                />
              ))}
            </RadioGroup>
          </ErrorSelect>
        )
      }
    </>
  );
};

export default MarksSelect;
